import { render, staticRenderFns } from "./SetupMerchant.vue?vue&type=template&id=2a2373b6"
import script from "./SetupMerchant.vue?vue&type=script&lang=js"
export * from "./SetupMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports